/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_search_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Hledat filtry...`
};

const da_search_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Søg i filtre...`
};

const de_search_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Filter suchen...`
};

const en_search_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Search filters...`
};

const es_search_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Buscar filtros...`
};

const fr_search_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Rechercher des filtres...`
};

const hu_search_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Szűrők keresése...`
};

const it_search_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Cerca filtri...`
};

const nl_search_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Filters zoeken...`
};

const pl_search_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Szukaj filtrów...`
};

const pt_search_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Pesquisar filtros...`
};

const sv_search_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Sök filter...`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const search_filters = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.search_filters(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("search_filters", locale)
	if (locale === "cs") return cs_search_filters(inputs)
	if (locale === "da") return da_search_filters(inputs)
	if (locale === "de") return de_search_filters(inputs)
	if (locale === "en") return en_search_filters(inputs)
	if (locale === "es") return es_search_filters(inputs)
	if (locale === "fr") return fr_search_filters(inputs)
	if (locale === "hu") return hu_search_filters(inputs)
	if (locale === "it") return it_search_filters(inputs)
	if (locale === "nl") return nl_search_filters(inputs)
	if (locale === "pl") return pl_search_filters(inputs)
	if (locale === "pt") return pt_search_filters(inputs)
	return sv_search_filters(inputs)
};